export default "__VITE_ASSET__CZUStuU9__"